export const vinMask = (vin: string = "") => {
    const lastSix = vin.substr(vin.length - 6);
    return "******" + lastSix;
};

export const formatPhone = (phone: number) => {
    const phoneLength = phone.toString().split("").length;
    let phoneSplit = phone.toString().split("");
    if (phoneLength === 10) {
        phoneSplit.splice(0, 0, "(");
        phoneSplit.splice(4, 0, ")");
        phoneSplit.splice(8, 0, "-");
        const phoneJoin = phoneSplit.join("");
        return phoneJoin;
    }
    if (phoneLength === 11) {
        phoneSplit.splice(1, 0, "(");
        phoneSplit.splice(5, 0, ")");
        phoneSplit.splice(9, 0, "-");
    }
    const phoneJoin = phoneSplit.join("");
    return phoneJoin;
};

export const statesObject: { [key: string]: string } = {
    AL: "Alabama",
    AK: "Alaska",
    AS: "American Samoa",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District Of Columbia",
    FM: "Federated States Of Micronesia",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MH: "Marshall Islands",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    MP: "Northern Mariana Islands",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PW: "Palau",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VI: "Virgin Islands",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
};

export const states = () => {
    return Object.values(statesObject);
};
